/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    Button,
    getPayloadObject,
    getTelemetryAttributes,
    ITelemetryContent,
    TelemetryConstant
} from '@msdyn365-commerce-modules/utilities';
import { observer } from 'mobx-react';
import * as React from 'react';

import { IGhHeaderResources } from '../gh-header.props.autogenerated';

export interface INavIconProps {
    resources: IGhHeaderResources;
    isExpanded: boolean;
    targetId: string;
    label?: string;
    telemetryContent?: ITelemetryContent;
    toggleNavBar(): void;
}

/**
 *
 * NavIcon component.
 * @extends {React.PureComponent<INavIconProps>}
 */

@observer
export class NavIcon extends React.PureComponent<INavIconProps> {
    private readonly attributes?: Msdyn365.IDictionary<string>;

    constructor(props: INavIconProps) {
        super(props);
        const payLoad = getPayloadObject('click', props.telemetryContent!, TelemetryConstant.NavIcon);
        this.attributes = getTelemetryAttributes(props.telemetryContent!, payLoad);
    }

    public render(): JSX.Element {
        return (
            <Button
                className='gh-header__nav-icon'
                onClick={this.props.toggleNavBar}
                title={this.props.resources.mobileHamburgerAriaLabel}
                aria-label={this.props.resources.mobileHamburgerAriaLabel}
                aria-expanded={this.props.isExpanded}
                aria-controls={this.props.targetId}
                {...this.attributes}
            >
                <span className='gh-header__nav-icon-bars' aria-hidden='true'>
                    <i />
                    <i />
                    <i />
                </span>
                {this.props.label && <span className='gh-header__nav-icon-label'>{this.props.label}</span>}
            </Button>
        );
    }
}
